import { useState } from "react";
import { Col, Row, Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { FilterSearchSectionProps } from "../../../types/organization/OrganizationList";
import SearchBar from "../../../common-elements/search-bar/SearchBar";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";

interface FilterAppVersionSectionProps extends FilterSearchSectionProps {
  selectedAppName: string;
  setSelectedAppName: (value: string) => void;
  selectedVersion: string;
  setSelectedVersion: (value: string) => void;
  searchWord: string;
  setSearchWord: (value: string) => void;
  selectedOrganization: string;
  setSelectedOrganization: (value: string) => void;
}

function FilterAppVersionSection({
  selectedAppName,
  setSelectedAppName,
  selectedVersion,
  setSelectedVersion,
  searchWord,
  setSearchWord,
  selectedOrganization,
  setSelectedOrganization,
}: FilterAppVersionSectionProps) {
  const { t } = useTranslation();

  // Set the initial state to 'false' so filters are hidden by default
  const [showFilters, setShowFilters] = useState(false);

  const organizationOptions = [
    {
      value: "Linnk group",
      label: "Linnk group",
      image: "logo/logo-icon.png",
    },
    {
      value: "Tech Solutions",
      label: "Tech Solutions",
      image: "logo/logo-icon.png",
    },
    {
      value: "Innovate Inc.",
      label: "Innovate Inc.",
      image: "logo/logo-icon.png",
    },
  ];

  const appNames = [
    "CRM Pro",
    "DevTools",
    "FinanceApp",
    "SocialConnect",
    "HR Portal",
    "SupportDesk",
    "AdminConsole",
  ];
  const versions = ["All", "Latest", "Old"];

  const appNameOptions = appNames.map((app) => ({ value: app, label: app }));
  const versionOptions = versions.map((version) => ({
    value: version,
    label: t(version),
  }));

  // This function toggles the visibility of the filter dropdowns
  const toggleFilters = () => setShowFilters(!showFilters);

  const formatOptionLabel = ({ label, image }: any) => (
    <div className="d-flex align-items-center">
      <Image src={dynamicImage(image)} alt={label} className="img-20 me-2" />
      {label}
    </div>
  );

  return (
    <div className="feature-products">
      <Row>
        <Col xl="12">
          <div className="d-flex justify-content-between align-items-center pb-3">
            <SearchBar
              label="Search"
              value={searchWord}
              onChange={(e) => setSearchWord(e.target.value)}
              placeholder={t("Search")}
            />
            <div className="d-flex gap-2">
              <Button color="primary" onClick={toggleFilters}>
                <i className="fa fa-filter" />
              </Button>
              <Button color="info">
                <i className="fa fa-upload" /> {t("Export")}
              </Button>
            </div>
          </div>

          {/* This section will now only render when 'showFilters' is true */}
          {showFilters && (
            <Row className="align-items-end">
              <Col sm="4" className="pb-3">
                <Select
                  options={organizationOptions}
                  className="basic-single-select"
                  classNamePrefix="select"
                  isSearchable={true}
                  isClearable
                  value={organizationOptions.find(
                    (opt) => opt.value === selectedOrganization
                  )}
                  onChange={(option) =>
                    setSelectedOrganization(option ? option.value : "")
                  }
                  formatOptionLabel={formatOptionLabel}
                />
              </Col>
              <Col sm="4" className="pb-3">
                <Select
                  options={appNameOptions}
                  placeholder={t("selectAppName")}
                  className="basic-single-select"
                  classNamePrefix="select"
                  isSearchable={true}
                  isClearable
                  value={
                    selectedAppName
                      ? { value: selectedAppName, label: selectedAppName }
                      : null
                  }
                  onChange={(option) =>
                    setSelectedAppName(option ? option.value : "")
                  }
                />
              </Col>
              <Col sm="4" className="pb-3">
                <Select
                  options={versionOptions}
                  placeholder={t("selectVersion")}
                  className="basic-single-select"
                  classNamePrefix="select"
                  isSearchable={true}
                  isClearable
                  value={
                    selectedVersion
                      ? { value: selectedVersion, label: t(selectedVersion) }
                      : null
                  }
                  onChange={(option) =>
                    setSelectedVersion(option ? option.value : "")
                  }
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default FilterAppVersionSection;
